/* eslint-disable */
// @ts-nocheck
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import MainDispatcher from '../support/MainDispatcher';
import type { AgencyRelationshipData, Permissions, Filters } from '../types/accessControlTypes';
import {
  simplifyPermissions,
  determineFilters,
  extractFeatureFilters,
} from '../../common/support/utils/accessControlHelpers';
import { updateTeamMember } from './TeamActions';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
const errorProvider = new ErrorProvider();
const InviteAgency = new ReduxAsyncAction('INVITE_AGENCY');
InviteAgency.registerRequest((agencyData: AgencyRelationshipData) => {
  return dash_api.post('/v1/agency-relationship', agencyData).then(({ data }) => data);
});
export const inviteAgency = InviteAgency.request;
export const INVITE_AGENCY = InviteAgency.constants;
const ResendAgencyInvite = new ReduxAsyncAction('RESEND_AGENCY_INVITE');
ResendAgencyInvite.registerRequest((agencyId: string) => {
  return dash_api
    .post('/v1/agency-relationship/resend-invite', {
      agency_id: agencyId,
    })
    .then(({ data }) => data);
});
export const resendAgencyInvite = ResendAgencyInvite.request;
export const RESEND_AGENCY_INVITE = ResendAgencyInvite.constants;
const FetchRelatedAgencies = new ReduxAsyncAction('FETCH_RELATED_AGENCIES');
FetchRelatedAgencies.registerRequest(() => {
  return dash_api.get('/v1/agency-relationship').then(({ data }) => data);
});
export const fetchRelatedAgencies = FetchRelatedAgencies.request;
export const FETCH_RELATED_AGENCIES = FetchRelatedAgencies.constants;
const FetchAgencyUsers = new ReduxAsyncAction('FETCH_AGENCY_USERS');
FetchAgencyUsers.registerRequest((agencyId) => {
  return dash_api.get(`/v1/agency-relationship/team/${agencyId}`).then(({ data }) => {
    return {
      agencyUsers: data,
      agencyId,
    };
  });
});
export const fetchAgencyUsers = FetchAgencyUsers.request;
export const FETCH_AGENCY_USERS = FetchAgencyUsers.constants;
const FetchAllAgencies = new ReduxAsyncAction('FETCH_ALL_AGENCIES');
FetchAllAgencies.registerRequest(() => {
  return dash_api.get('/v1/agency-relationship/fetch-all').then(({ data }) => data);
});
export const fetchAllAgencies = FetchAllAgencies.request;
export const FETCH_ALL_AGENCIES = FetchAllAgencies.constants;
export const AcceptInvite = new ReduxAsyncAction('ACCEPT_INVITE');
AcceptInvite.registerRequest((token) => {
  return dash_api
    .post('/v1/agency-relationship/accept-invite', {
      token: token,
    })
    .then(({ data }) => data);
});
export const acceptInvite = AcceptInvite.request;
export const ACCEPT_INVITE = AcceptInvite.constants;
const FetchPermissionsForAgency = new ReduxAsyncAction('FETCH_AGENCY_PERMISSIONS');
FetchPermissionsForAgency.registerRequest((agencyId: string) => {
  return dash_api.get(`/v1/agency-relationship/permissions/agency/${agencyId}`).then(({ data }) => ({
    agencyId,
    permissions: {
      access_role_id: data.access_role_id < 200 ? Number(data.access_role_id) : data.access_role_id,
      permissions: simplifyPermissions(data.permissions),
      filters: determineFilters(data.permissions),
      featureFilters: extractFeatureFilters(data.permissions),
    },
  }));
});
export const fetchPermissionsForAgency = FetchPermissionsForAgency.request;
export const FETCH_AGENCY_PERMISSIONS = FetchPermissionsForAgency.constants;
const FetchPermissionsForAgencyUser = new ReduxAsyncAction('FETCH_AGENCY_USER_PERMISSIONS');
FetchPermissionsForAgencyUser.registerRequest((userId: string) => {
  return dash_api
    .get(`/v1/agency-relationship/permissions/user/${userId}`)
    .then(({ data }) => ({
      userId,
      permissions: {
        ...data,
        permissions: simplifyPermissions(data.permissions),
        filters: determineFilters(data.permissions),
        featureFilters: extractFeatureFilters(data.permissions),
      },
    }))
    .catch((err) => {
      return {
        userId,
        permissions: true,
      };
    });
});
export const fetchPermissionsForAgencyUser = FetchPermissionsForAgencyUser.request;
export const FETCH_AGENCY_USER_PERMISSIONS = FetchPermissionsForAgencyUser.constants;
const UpdateAgencyOrg = new ReduxAsyncAction('UPDATE_AGENCY_ORG');
UpdateAgencyOrg.registerRequest(
  (
    toOrganizationId: string,
    uiRoleId: string,
    permissions: Permissions,
    filters: Filters,
    apps: Array<string> | null | undefined,
    resetAllApps: boolean | null | undefined,
    resetAllUsers: boolean | null | undefined,
    label: string | null | undefined
  ) => {
    return dash_api
      .put('/v1/agency-relationship', {
        toOrganizationId,
        uiRoleId,
        permissions,
        filters,
        apps,
        resetAllApps,
        resetAllUsers,
        label,
      })
      .then(({ data }) => data);
  }
);
export const updateAgencyOrg = UpdateAgencyOrg.request;
export const UPDATE_AGENCY_ORG = UpdateAgencyOrg.constants;
export const updateAndReloadMembers =
  (
    userId: string,
    name: string,
    agencyId: string,
    accessRoleId: string,
    permissions: Permissions,
    filters: Filters,
    apps: Array<string> | null | undefined,
    resetAllApps: boolean | null | undefined
  ) =>
  (dispatch: (...args: Array<any>) => any) => {
    return dispatch(updateTeamMember(userId, name, accessRoleId, permissions, filters, apps, resetAllApps, agencyId))
      .then(() => dispatch(fetchAgencyUsers(agencyId)))
      .catch((err) => {
        MainDispatcher.dispatch({
          action: 'TEAM_ERROR',
          error: err && err.message,
        });
      });
  };
const ResetAgencyUserToInherit = new ReduxAsyncAction('RESET_AGENCY_USER_TO_INHERIT');
ResetAgencyUserToInherit.registerRequest((userId: string, agencyId: string) => {
  return dash_api
    .post('/v1/agency-relationship/reset-agency-entity-to-inherit', {
      userId,
      agencyId,
    })
    .then(() => {
      MainDispatcher.dispatch({
        action: 'AGENCY_USER_RESET_TO_INHERIT',
      });
      return {
        id: userId,
      };
    });
});
const resetAgencyUserToInheritWithoutReload = ResetAgencyUserToInherit.request;
export const RESET_AGENCY_USER_TO_INHERIT = ResetAgencyUserToInherit.constants;
export const resetAgencyUserToInherit = (userId: string, agencyId: string) => (dispatch: (...args: Array<any>) => any) => {
  return dispatch(resetAgencyUserToInheritWithoutReload(userId as string, agencyId as string))
    .then(() => {
      if (userId) {
        return dispatch(fetchAgencyUsers(agencyId));
      } else {
        return dispatch(fetchRelatedAgencies());
      }
    })
    .catch((err) => {
      MainDispatcher.dispatch({
        action: 'AGENCY_ERROR',
        error: 'Failed to reset agency user to inherit',
      });
    });
};
export const updateAndReloadAgencies =
  (
    toOrganizationId: string,
    accessRoleId: string,
    permissions: Permissions,
    filters: Filters,
    apps: Array<string> | null | undefined,
    resetAllApps: boolean | null | undefined,
    resetAllUsers: boolean | null | undefined,
    label: string | null | undefined
  ) =>
  (dispatch: (...args: Array<any>) => any) => {
    return dispatch(
      updateAgencyOrg(toOrganizationId, accessRoleId, permissions, filters, apps, resetAllApps, resetAllUsers, label)
    )
      .then(() => dispatch(fetchRelatedAgencies()))
      .catch((err) => {
        MainDispatcher.dispatch({
          action: 'UPDATE_AGENCY_ORG_ERROR',
          error: err && err.message,
        });
      });
  };
const FetchCountries = new ReduxAsyncAction('FETCH_COUNTRIES');
FetchCountries.registerRequest(() => {
  return dash_api.get('/v1/agency-relationship/countries').then(({ data }) => data);
});
export const fetchCountries = FetchCountries.request;
export const FETCH_COUNTRIES = FetchCountries.constants;
const DeleteAgency = new ReduxAsyncAction('DELETE_AGENCY');
DeleteAgency.registerRequest((agencyId: string, name: string) => {
  return dash_api.delete('/v1/agency-relationship', {
    data: {
      to_organization_id: agencyId,
      name,
    },
  });
});
export const deleteAgency = DeleteAgency.request;
export const DELETE_AGENCY = DeleteAgency.constants;
export const deleteAndReloadAgencies = (agencyId: string, name: string) => (dispatch: (...args: Array<any>) => any) => {
  return dispatch(deleteAgency(agencyId, name))
    .then(() => dispatch(fetchRelatedAgencies()))
    .catch((err) => {
      MainDispatcher.dispatch({
        action: 'DELETE_AGENCY_ERROR',
        error: errorProvider.parse(err).getMessageOrEmpty(),
      });
    });
};
